export default defineNuxtPlugin(() => {
  const gtm = useGtm()

  if (gtm) {
    const originalTrackEvent = gtm.trackEvent.bind(gtm)
    const $route = useRoute()

    gtm.trackEvent = (options: Record<string, any>) => {
      return originalTrackEvent({
        ...options,
        'content-view-name': $route.name || $route.path, // 👈 добавляем глобально
      })
    }
  }
})
